import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import env from "../../env";
const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        children: [
            {
                path: '/smstemplate',
                name: 'sms-template',
                meta: {
                    title: '短信模板'
                },
                component: () => import(
                    '../views/SmsTemplate.vue')
            },
            {
                path: '/addsms',
                name: 'add-sms',
                meta: {
                    title: '充值短信'
                },
                component: () => import(
                    '../views/AddSms.vue')
            },
            {
                path: '/store',
                name: 'store',
                meta: {
                    title: '门店（全部）'
                },
                component: () => import(
                    '../views/StoreTable.vue')
            },
            {
                path: '/storelower',
                name: 'storelower',
                meta: {
                    title: '门店部分'
                },
                component: () => import(
                    '../views/StoreLower.vue')
            },
            {
                path: '/room',
                name: 'room',
                meta: {
                    title: '房间'
                },
                component: () => import(
                    '../views/RoomTable.vue')
            },
            {
                path: '/roomlower',
                name: 'roomlower',
                meta: {
                    title: '房间部分'
                },
                component: () => import(
                    '../views/RoomLower.vue')
            },
            {
                path: '/manager',
                name: 'manager',
                meta: {
                    title: '店长'
                },
                component: () => import(
                    '../views/ManagerTable.vue')
            },
            {
                path: '/clear',
                name: 'clear',
                meta: {
                    title: '保洁'
                },
                component: () => import(
                    '../views/TheCleaning.vue')
            },
            {
                path: '/device',
                name: 'device',
                meta: {
                    title: '设备信息'
                },
                component: () => import(
                    '../views/DeviceTable.vue')
            },
            {
                path: '/status',
                name: 'status',
                meta: {
                    title: '设备状态'
                },
                component: () => import(
                    '../views/ConnectTable.vue')
            },
            {
                path: '/admin',
                name: 'admin',
                meta: {
                    title: '用户管理'
                },
                component: () => import(
                    '../views/AdminTable.vue')
            },
            {
                path: '/menu',
                name: 'menu',
                meta: {
                    title: '菜单管理'
                },
                component: () => import(
                    '../views/SetMenu.vue')
            },
            {
                path: '/order',
                name: 'order',
                meta: {
                    title: '订单管理'
                },
                component: () => import(
                    '../views/OrderTable.vue')
            },
            {
                path: '/express',
                name: 'express',
                meta: {
                    title: '物流管理'
                },
                component: () => import(
                    '../views/ExpressTable.vue')
            },
            {
                path: '/finance',
                name: 'finance',
                meta: {
                    title: '收入'
                },
                component: () => import(
                    '../views/FinanceTable.vue')
            },
            {
                path: '/refund',
                name: 'refund',
                meta: {
                    title: '退款'
                },
                component: () => import(
                    '../views/TheRefund.vue')
            },
            {
                path: '/recharge',
                name: 'recharge',
                meta: {
                    title: '充值记录'
                },
                component: () => import(
                    '../views/RechargeRecord.vue')
            },
            {
                path: '/rules',
                name: 'rules',
                meta: {
                    title: '充值规则'
                },
                component: () => import(
                    '../views/BalanceRulesTable.vue')
            },
            {
                path: '/user',
                name: 'user',
                meta: {
                    title: '会员管理'
                },
                component: () => import(
                    '../views/UserTable.vue')
            },
            {
                path: '/coupon',
                name: 'coupon',
                meta: {
                    title: '优惠券管理'
                },
                component: () => import(
                    '../views/CouponTable.vue')
            },
            {
                path: '/couponrecord',
                name: 'couponrecord',
                meta: {
                    title: '优惠券记录'
                },
                component: () => import(
                    '../views/CouponUser.vue')
            },
            {
                path: '/setting',
                name: 'setting',
                meta: {
                    title: '基本配置'
                },
                component: () => import(
                    '../views/setType.vue')
            },
            {
                path: '/problem',
                name: 'problem',
                meta: {
                    title: '常见问题'
                },
                component: () => import(
                    '../views/ArticleTable.vue')
            },
            {
                path: '/instructions',
                name: 'instructions',
                meta: {
                    title: '使用说明'
                },
                component: () => import(
                    '../views/InstructionsTable.vue')
            },
            {
                path: '/devicelog',
                name: 'devicelog',
                meta: {
                    title: '设备日志'
                },
                component: () => import(
                    '../views/DailyRecord.vue')
            },
            {
                path: '/actor',
                name: 'actor',
                meta: {
                    title: '角色管理'
                },
                component: () => import(
                    '../views/ActorTable.vue')
            },
            {
                path: '/connectlog',
                name: 'connectlog',
                meta: {
                    title: '连接日志'
                },
                component: () => import(
                    '../views/ConnectRecord.vue')
            },
            {
                path: '/couponlog',
                name: 'couponlog',
                meta: {
                    title: '优惠券日志'
                },
                component: () => import(
                    '../views/CouponRecord.vue')
            },
            {
                path: '/messagelog',
                name: 'messagelog',
                meta: {
                    title: '短信日志'
                },
                component: () => import(
                    '../views/MessageRecord.vue')
            },
            {
                path: '/product',
                name: 'product',
                meta: {
                    title: '商城商品'
                },
                component: () => import(
                    '../views/ProductTable.vue')
            },
            {
                path: '/container',
                name: 'container',
                meta: {
                    title: '货柜商品'
                },
                component: () => import(
                    '../views/PiaProductTable.vue')
            },
            {
                path: '/meal',
                name: 'meal',
                meta: {
                    title: '套餐'
                },
                component: () => import(
                    '../views/MealTable.vue')
            },
            {
                path: '/company',
                name: 'company',
                meta: {
                    title: '加盟商'
                },
                component: () => import(
                    '../views/CompanyTable.vue')
            },
            {
                path: '/agent',
                name: 'agent',
                meta: {
                    title: '代理商'
                },
                component: () => import(
                    '../views/AgentTable.vue')
            },
            {
                path: '/join',
                name: 'join',
                meta: {
                    title: '加盟申请'
                },
                component: () => import(
                    '../views/JoinApply.vue')
            },
            {
                path: '/user_rule',
                name: 'user_rule',
                meta: {
                    title: '会员评估规则'
                },
                component: () => import(
                    '../views/UserRules.vue')
            },
            {
                path: '/marketing_activities',
                name: 'marketing_activities',
                meta: {
                    title: '营销活动'
                },
                component: () => import(
                    '../views/ActivityList.vue')
            },
            {
                path: '/card_coupons',
                name: 'card_coupons',
                meta: {
                    title: '卡券管理'
                },
                component: () => import(
                    '../views/CardCoupons.vue')
            },
            {
                path: '/card_coupon_record',
                name: 'card_coupon_record',
                meta: {
                    title: '卡券日志'
                },
                component: () => import(
                    '../views/CardCouponRecord.vue')
            },
            {
                path: '/store_coupon',
                name: 'store_coupon',
                meta: {
                    title: '商城优惠券'
                },
                component: () => import(
                    '../views/StoreCouponTable.vue')
            },
            
            {
                path: '/404',
                name: '404',
                meta: {
                    title: '找不到页面'
                },
                component: () => import(/* webpackChunkName: "404" */
                    '../views/404.vue')
            },
            {
                path: '/403',
                name: '403',
                meta: {
                    title: '没有权限'
                },
                component: () => import(/* webpackChunkName: "403" */
                    '../views/403.vue')
            }
        ]
    }, {
        path: "/login",
        name: "Login",
        meta: {
            title: '平台登录'
        },
        component: () => import(
            /* webpackChunkName: "login" */
            "../views/Login.vue")
    }
];

const router = createRouter({
    history: createWebHashHistory(env.productBase),
    routes
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    if (to.path === '/login') {
        next();
    } else if (document.title === `undefined`) {
        next('/login');
    } else {
        const overTime = localStorage.getItem("overTime")
        let token = localStorage.getItem("token")
        if (token === undefined || token === 'undefined' || overTime === undefined || overTime < Date.parse(new Date()) - 43200 * 1000) {
            next('/login');
        } else {
            next();
        }

    }
});

export default router;
